'use client';

import { useEffect } from 'react';

type Props = {
  /**
   * 目的: hashに該当するID要素へスクロールさせる（Next.jsのスクロール制御でアンカーが効かないケースの対策）
   * 引数:
   * - behavior: スクロールの挙動（'auto' | 'smooth'）
   * 戻り値: JSX.Element（描画はしない）
   */
  behavior?: ScrollBehavior;
};

/**
 * HashAnchorScroll
 *
 * 目的:
 * - URLに `#...` が付いている場合、該当ID要素へ確実にスクロールする
 *
 * 想定される例外:
 * - hashに対応する要素が存在しない（その場合は何もしない）
 */
export default function HashAnchorScroll({ behavior = 'auto' }: Props) {
  useEffect(() => {
    const scrollToHash = () => {
      try {
        const raw = window.location.hash;
        const id = raw?.startsWith('#') ? raw.slice(1) : raw;
        if (!id) return;
        const el = document.getElementById(id);
        if (!el) return;
        el.scrollIntoView({ behavior, block: 'start' });
      } catch (e) {
        console.error('[アンカースクロールエラー]', e);
      }
    };

    // 初回遷移時にNext.js側のスクロールが後から走る場合があるため、少し遅延して実行する
    const t = window.setTimeout(scrollToHash, 50);

    // hashだけが変わるケースも拾う
    window.addEventListener('hashchange', scrollToHash);

    return () => {
      window.clearTimeout(t);
      window.removeEventListener('hashchange', scrollToHash);
    };
  }, [behavior]);

  return null;
}


